<template>
    <div class="notificationBar shadowBottom text-center bg-color-1 lightest" :class="{'active':isUpdateAvailable}">
        <b>New Update:</b> more features, improvements and better navigation.
        <button class="bg-color-1 lightest border-lightest radius-normal ml-4 pointer px-3 btn" @click="reloadApp">Update Now</button>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getisAppUpToDate'
        ]),
        isUpdateAvailable: function () {
            return this.getisAppUpToDate != null && this.getisAppUpToDate == false
        }
    },
    methods: {
        reloadApp: function() {
            location.reload(true);
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';

.notificationBar{
    max-height: 0;
    transition: 400ms all ease-in-out;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    overflow: hidden;

    &.active{
        max-height: 4em;
        padding-top: 0.75em !important;
        padding-bottom: 0.75em !important;
    }
}
</style>



// WEBPACK FOOTER //
// topbarMessage.vue?cd015880